<template>
  <div class="contents contents--pt">
    <section class="Form _min-h">
      <div class="inner">
        <div class="Form--pt">
          <p class="Form__tx Form__tx--mb_sm">
            メールの配信設定をお選びください。
          </p>
          <div class="Form__area">
            <p class="Form__label Form__label--sp Form__label_setting Form__label--md">
              メールでは、スペシャルイベントの情報やマインドフルネスに関する記事などをお送りしています。
            </p>
            <div class="Form__input_box">
              <div class="Radio__area Form__radio Form__radio--mt_lg">
                <label class="Radio__box Form__radio_box">
                  <input v-model="userInfo.is_received_mail_promotion" class="Radio__box_input" type="radio" name="radio" value="1">
                  <span class="Radio__box_input_dummy" />
                  <span class="Radio__box_tx">配信する</span>
                </label>
                <label class="Radio__box Form__radio_box">
                  <input v-model="userInfo.is_received_mail_promotion" class="Radio__box_input" type="radio" name="radio" value="0">
                  <span class="Radio__box_input_dummy" />
                  <span class="Radio__box_tx">配信しない</span>
                </label>
              </div>
            </div>
            <button class="Btn__blue Form__btn Form__btn--sm_sp Form__btn--mt_md Form__btn--mt_lg Form__btn--mt_sp_lg" @click="updateUserInfo()">
              変更する
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import authService from '@/services/authService'
import { redirect } from '@/helpers'
export default {
  name: 'ChangeEmail',
  data() {
    return {
      userInfo: {
        is_received_mail_promotion: true
      },
      isLoading: false,
      showError: false
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      await this.getUserInfo()
    },
    async getUserInfo() {
      this.$store.dispatch('loading/updateLoading', true)
      const response = await authService.getUserInfo()
      const userInfoData = response.user.user
      this.userInfo.is_received_mail_promotion = userInfoData.is_received_mail_promotion
      this.$store.dispatch('loading/updateLoading', false)
    },
    async updateUserInfo() {
      const redirectPath = '/change/e-mail/thanks'
      this.$store.dispatch('loading/updateLoading', true)
      this.userInfo.is_received_mail_promotion = this.userInfo.is_received_mail_promotion !== '0'
      await authService.updateUserInfo(this.userInfo)
      this.$store.dispatch('loading/updateLoading', false)
      redirect(redirectPath)
    }
  }
}
</script>
